import { Box, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import Cars from "../../cars/Cars";
import WeekCalendar from "./WeekCalendar";
import dayjs from "dayjs";
import TableData from "../../table/TableData";
import axios from "axios";
import { url } from "../../../utils/url";
import { changeDateFormat } from "../../../utils/functions";

const WeeklyReport = () => {
  const [carId, setCarId] = useState("");
  const [date, setDate] = useState(dayjs(new Date()));
  const [week, setWeek] = useState([]);
  const [emptyWeek, setEmptyWeek] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const monday = date.clone().set("day", 1).toISOString();
    const friday = date.clone().set("day", 5).toISOString();
    setEmptyWeek(false);
    setError(null);
    setWeek([]);

    if (!carId) {
      return;
    }

    (async () => {
      try {
        const checkTravelRequest = await axios.get(`${url}travels/${monday}?toDate=${friday}&vehicleId=${carId}`, { withCredentials: true });

        if (!checkTravelRequest.data.length) {
          setEmptyWeek(true);
          return;
        }

        const getUsers = await axios.get(`${url}users`, { withCredentials: true });
      
        const weeklyTable = checkTravelRequest.data.map((row) => (row.data ? { ...row, data: JSON.parse(row.data), row } : row));
        weeklyTable.sort(function (a, b) {
          const dateA = new Date(a.date),
            dateB = new Date(b.date);
          return dateA - dateB;
        });

        const weeklyTableWithUsers = weeklyTable.map((row) => {
          const find = getUsers.data.find((user) => user.id === row.userId);
          if (find) {
            row.firstName = find.firstName;
            return row;
          }
          return row;
        });
        setWeek(weeklyTableWithUsers);
      } catch (err) {
        console.log(err);
        setError("Възникна проблем! Моля опитайте по-късно");
      }
    })();
  }, [carId, date]);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "30px",
        padding: {
          xs: 0,
          lg: "30px",
        },
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-evenly",
          alignItems: "center",
          width: "60%",
          flexDirection: {
            xs: "column",
            lg: "row",
          },
        }}
      >
        <WeekCalendar date={date} setDate={setDate} />
        <Cars setCarId={setCarId} />
      </Box>
      {error && <Typography color="red">{error}</Typography>}
      {emptyWeek ? (
        <Typography>Няма информация за тази седмица</Typography>
      ) : (
        week.map((rows) => (
          <Box key={rows.id}>
            <Box display="flex" justifyContent="center">
              <Typography marginRight="10px">{changeDateFormat(rows.date)}</Typography>
              <Typography>{rows.firstName}</Typography>
            </Box>
            <TableData rows={rows.data} checkedTable={rows.travelVerifStatusId} />
            <Typography>{rows.notes}</Typography>
          </Box>
        ))
      )}
    </Box>
  );
};

export default WeeklyReport;
